
import { defineComponent, PropType } from "vue";
import DashboardMoveControls from "@/components/dashboard/DashboardMoveControls.vue";

interface SeqNoticeButton {
  label: string;
  color?: string;
  size?: string;
  href?: string;
  target?: string;
  id?: string | number;
}

const DEFAULT_ICONS: Record<string, string> = {
  warning: "media/icons/duotone/Code/Warning-1-circle.svg",
  danger: "media/icons/duotone/Code/Warning-1-circle.svg",
  success: "media/icons/duotone/General/Like.svg",
  info: "media/icons/duotone/Code/Info-circle.svg"
};

export default defineComponent({
  name: "SeqNoticeCard",
  components: {
    DashboardMoveControls,
  },
  props: {
    variant: {
      type: String,
      default: "warning",
      validator: (value: string) =>
        ["warning", "success", "info", "danger"].includes(value)
    },
    title: { type: String, default: "" },
    icon: { type: String, default: "" },
    enableMoveControls: { type: Boolean, default: false },
    buttons: {
      type: Array as PropType<SeqNoticeButton[]>,
      default: () => []
    }
  },
  emits: ["action"],
  computed: {
    resolvedIcon(): string {
      return this.icon || DEFAULT_ICONS[this.variant] || DEFAULT_ICONS.warning;
    }
  },
  methods: {
    buttonClass(button: SeqNoticeButton): string[] {
      const classes = [`btn-${button.color || "primary"}`];
      if (button.size) {
        classes.push(`btn-${button.size}`);
      }
      return classes;
    },
    onButtonClick(button: SeqNoticeButton, index: number): void {
      this.$emit("action", button.id !== undefined ? button.id : index, button);
    }
  }
});
